import { Injectable } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  AbstractControl,
} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class AddTransactionTypeForm {
  form: UntypedFormGroup;

  constructor(private _formBuilder: UntypedFormBuilder) {
    this.initializeForm();
  }

  initializeForm() {
    this.form = this._formBuilder.group({
      transactionTypeDescription: ['', Validators.required],
      invoiceHeaderDescription: ['', Validators.required],
      invoicePrefix: ['', [Validators.required, this.alphaNumericValidator]],
      spendCategory: [{ value: null, disabled: false }, Validators.required],
      isHandKey: ['', Validators.required],
      isUpcIdentified: ['', Validators.required],
      hasEpFee: ['', Validators.required],
    });

    this.toggleNonHandKeyControls(false);
  }

  toggleNonHandKeyControls(isHandKey: boolean) {
    if (isHandKey) {
      this.form.removeControl('costCenter');
      this.form.removeControl('chain');
      this.form.removeControl('fileUpload');
      this.form.removeControl('invoiceType');
      this.form.removeControl('hasSupportingDocument');
      this.form.removeControl('supportingDocumentFile');
    } else {
      this.form.addControl(
        'costCenter',
        this._formBuilder.control('', [Validators.required]),
      );
      this.form.addControl(
        'chain',
        this._formBuilder.control('', Validators.required),
      );
      this.form.addControl(
        'fileUpload',
        this._formBuilder.control(null, Validators.required),
      );
      this.form.addControl(
        'invoiceType',
        this._formBuilder.control('', Validators.required),
      );
      this.form.addControl(
        'isUpcIdentified',
        this._formBuilder.control('', Validators.required),
      );
      this.form.addControl(
        'hasSupportingDocument',
        this._formBuilder.control('', Validators.required),
      );
      this.form.addControl(
        'supportingDocumentFile',
        this._formBuilder.control(''),
      );
    }
  }

  setRequiredDigitsError(control: AbstractControl) {
    if (
      control &&
      control.value !== null &&
      control.value !== '' &&
      control.value.toString().length < 3
    ) {
      return { isRequiredDigits: true };
    }
    return null;
  }

  fileTypeValidator(control: AbstractControl) {
    if (control.errors?.invalidFileType) {
      return { invalidFileType: true };
    }
    return null;
  }

  alphaNumericValidator(control: AbstractControl) {
    const value = control.value;

    if (value === null || value === undefined || value === '') return null;

    const s = String(value).trim();
    if (!s) return null;

    return /^[a-zA-Z0-9]+$/.test(s) ? null : { nonAlphaNumeric: true };
  }

  removeIsHandKeyControl() {
    this.form.removeControl('isHandKey');
  }
}
